// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6179":"css/admin-app.6870","8364":"css/app.6870"}[chunkId] + ".css";
};